// Same-origin beacon transport for RUM performance samples → POST /api/web-vitals.
// The server records each sample as an OTLP histogram (see the route), which is
// what reaches the Better Stack source. Fire-and-forget via `navigator.sendBeacon`
// so it never blocks rendering or page-unload, and — being same-origin — survives
// the ad-blockers that drop the third-party Better Stack tag.

const ENDPOINT = '/api/web-vitals';

export function beaconVitals(payload: Record<string, string | number>): void {
  if (typeof navigator === 'undefined' || typeof navigator.sendBeacon !== 'function') return;
  try {
    const blob: Blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
    navigator.sendBeacon(ENDPOINT, blob);
  } catch {
    // SILENT-CATCH: telemetry must never crash the page.
  }
}
